import { Factory } from 'fishery'
import { OpalApiResponseDocument } from '@opallabs/api'
import { factories } from '../..'

type ConnectorCandidates = OpalApiResponseDocument<
  'ReadBlockConnectorCandidatesBFFV1',
  200
>

export const blockConnectorCandidatesFactory: Factory<ConnectorCandidates> =
  Factory.define<ConnectorCandidates>(() => {
    return {
      data: factories.asgardBff.components.connectorCandidate.buildList(2),
    } satisfies ConnectorCandidates
  })
